// Date helpers shared by the document list pages (Pulling, Proposal, Tally,
// Chemical Tracker, Additional Documents).

// Accepts either a date-only string ("2026-10-14") or a full ISO timestamp.
// Date-only values are parsed at local noon so timezone shifts can't move the day.
export const parseDocDate = (d?: string | null): Date | null => {
  if (!d) return null;
  const dt = new Date(d.includes("T") ? d : d + "T12:00:00");
  return isNaN(dt.getTime()) ? null : dt;
};

export const fmtDate = (d?: string | null) => {
  const dt = parseDocDate(d);
  return dt ? `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}` : "—";
};

// The date a user picked in the upload form (`installationDate`) wins over the
// server-set upload timestamp (`date`).
export const displayDate = (item: {
  installationDate?: string | null;
  date?: string | null;
}) => item.installationDate || item.date || "";

// `from` / `to` are "YYYY-MM-DD" values from the filter inputs ("" = open-ended).
export const dateInRange = (d: string, from: string, to: string) => {
  const dt = parseDocDate(d);
  if (!dt) return false;
  if (from && dt < new Date(from + "T00:00:00")) return false;
  if (to && dt > new Date(to + "T23:59:59")) return false;
  return true;
};
